import { Component, Input, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { RegexEnum } from '../../../../../../enums/regex.enum'
import { UrlAnalysisType } from '../analysis-url-manager.component'

export type FormFilterType = { label: FormControl<string | null>; url: FormControl<string | null> }
@Component({
    selector: 'app-add-url-modal',
    templateUrl: './add-url-modal.component.html',
    standalone: false
})
export class AddUrlModalComponent implements OnInit {
  @Input() urlAnalysis: UrlAnalysisType

  public formFilter: FormGroup<FormFilterType>
  public label: FormControl<string | null>
  public url: FormControl<string | null>

  constructor(private activeModal: NgbActiveModal) {}

  private initControls(): void {
    this.label = new FormControl<string | null>(null, [
      Validators.required,
      Validators.maxLength(30),
    ])
    this.url = new FormControl<string | null>(null, [
      Validators.required,
      Validators.pattern(RegexEnum.REGEX_URL),
    ])
  }

  private initForm(): void {
    this.formFilter = new FormGroup<FormFilterType>({
      label: this.label,
      url: this.url,
    })
  }

  public applyFilters(): void {
    if (this.formFilter.valid) {
      this.activeModal.close({
        id: this.urlAnalysis ? this.urlAnalysis.id : 0,
        label: this.formFilter.get('label').value,
        url: this.formFilter.get('url').value,
      })
    }
  }

  public changed(): boolean {
    if (this.urlAnalysis) {
      return (
        JSON.stringify(this.urlAnalysis) !==
        JSON.stringify({
          label: this.formFilter.get('label').value,
          url: this.formFilter.get('url').value,
        })
      )
    }
    return true
  }

  public ngOnInit(): void {
    this.initControls()
    this.initForm()

    if (this.urlAnalysis) {
      this.formFilter.patchValue({
        url: this.urlAnalysis.url,
        label: this.urlAnalysis.label,
      })
    }
  }
}
